/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ChangeRequestDeleteRequest = {
    changeRequestIds?: Array<number>;
    changeRequestType?: ChangeRequestDeleteRequest.changeRequestType;
};
export namespace ChangeRequestDeleteRequest {
    export enum changeRequestType {
        COMPETITOR = 'COMPETITOR',
        FRESHNESS = 'FRESHNESS',
        INSTRUCTION = 'INSTRUCTION',
        FLYER = 'FLYER',
    }
}

